import template from './trip-item-rail-recommendation.html';
import tripEvents from './../../config/events.constant';
import tripStatuses from './../../trip-statuses';

const DIRECTIVE_NAME = TripItemRailRecommendation.DIRECTIVE_NAME = 'ktTripItemRailRecommendation';
export default function TripItemRailRecommendation() {
    return {
        restrict: 'A',
        template,
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            cancellation: `=${DIRECTIVE_NAME}Cancellation`,
            cancelTrip: `=${DIRECTIVE_NAME}CancelTrip`,
            isCancelled: `=${DIRECTIVE_NAME}IsCancelled`,
            getTooltip: `=${DIRECTIVE_NAME}GetTooltip`,
            showAcceptDismissForBooker: `=${DIRECTIVE_NAME}ShowAcceptDismissForBooker`,
            lastReview: `=${DIRECTIVE_NAME}LastReview`,
        },
        controller: TripItemRailRecommendationController,
        controllerAs: 'tripItemRailRecommendationCtrl',
        link: function($scope, $elem, $attrs, tripItemRailRecommendationCtrl) {
            tripItemRailRecommendationCtrl.$onInit();
        },
    };
}

export function TripItemRailRecommendationController(
    $scope,
    tripItemService,
    railsUtils,
    tripUtils,
    userService,
    tripItemRailRecommendationService,
    tripDetailsService,
    moment,
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        moment,
    });

    Object.assign($scope, {
        cancelTripItem,
        applyReview,
        isItemReviewed,
        isTripItemIdDeclined,
        isTripItemIdApproved,
        isItemNotIndicated,
        itemCannotBeCancelled: tripItemService.itemCannotBeCancelled,
    });

    function $onInit() {
        $scope.seatsCount = tripDetailsService.getSeatsCount($scope.tripDetails);
        $scope.regionalSettings = userService.getRegionalSettings();
        $scope.travellersCount = tripDetailsService.getTravellersCount($scope.tripDetails);

        $scope.firstRail = railsUtils.firstRail;
        $scope.lastRail = railsUtils.lastRail;
        $scope.findFlightStop = railsUtils.findFlightStop;
        $scope.collectAllStationCities = tripItemRailRecommendationService.getAllStations;
        $scope.findDestination = railsUtils.findDestination;
        $scope.railType = railsUtils.railType;
        $scope.isTrain = railsUtils.isItemTrain;
        $scope.generateRulesParameters = tripUtils.generateRulesParameters;
        $scope.showItemReviewStatus = $scope.lastReview && $scope.lastReview.needToShowTripItems() && $scope.showAcceptDismissForBooker();
        $scope.isNotCCUser = $scope.tripDetails.ReviewTripInfo.CanBeCommented || $scope.tripDetails.ReviewTripInfo.CanBeAccepted;
        $scope.isSingleReviewer = $scope.tripDetails.ReviewTripInfo.CanBeAccepted;
        $scope.tripDetails.reviewModel = $scope.tripDetails.reviewModel || {flights: {}, cars: {}, hotels: {}, rails: {}};
        $scope.isTripConfirmed = isTripConfirmed();
    }

    function cancelTripItem(item) {
        this.cancellation.cancellingWholeTrip = false;
        $scope.$emit(tripEvents.TRIP_CANCEL_ITEM, item);
    }

    function applyReview(rail, isAccepted) {
        $scope.tripDetails.reviewModel.rails[rail.Id] = isAccepted;
    }

    function isItemReviewed(railId) {
        return $scope.tripDetails.reviewModel
            && $scope.tripDetails.reviewModel.rails
            && $scope.tripDetails.reviewModel.rails.hasOwnProperty(railId);
    }

    function isTripItemIdDeclined(tripItemId) {
        return $scope.showItemReviewStatus && $scope.lastReview.getFirstUserReview().isTripItemIdDeclined(tripItemId);
    }

    function isTripItemIdApproved(tripItemId) {
        return $scope.showItemReviewStatus && $scope.lastReview.getFirstUserReview().isTripItemIdApproved(tripItemId);
    }

    function isItemNotIndicated(tripItemId) {
        return $scope.showItemReviewStatus
            && $scope.lastReview.getFirstUserReview().isTripItemIdNotInticated(tripItemId);
    }

    function isTripConfirmed() {
        return $scope.tripDetails.Status === tripStatuses.CONFIRMED;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-rail-recommendation/trip-item-rail-recommendation-component.js